import { gql } from '@apollo/client';

/*
 ** ADD BROADCAST LIVE **
 */

export const ADD_BROADCAST_LIVE = gql`
  mutation AddBroadcastLive($input: AddBroadcastLiveInput!) {
    addBroadcastLive(input: $input) {
      broadcastLive {
        blId
      }
      message
    }
  }
`;

export type AddBroadcastLiveResult = {
  blId: string;
};

export type AddBroadcastLiveData = {
  addBroadcastLive: {
    broadcastLive: AddBroadcastLiveResult | null;
    message: string;
  } | null;
};

export type AddBroadcastLiveInput = {
  clusterRegion: string;
  thumbnailUrl: string;
  dvrWindow: number;
  endTime: string;
  ingestFormat: string;
  startTime: string;
  streamType: string;
  title: string;
  description?: string;
};

export type AddBroadcastLiveVariables = {
  input: AddBroadcastLiveInput;
};
